module.exports = __webpack_public_path__ + "img/first@2x.97712448.png";